import { connect } from 'react-redux';
import StudentKbk from '../../../views/Student/report/StudentKbk.student.view';

export default connect(null, null)(StudentKbk);
